import { createContext } from 'preact/compat';
import { GlobalContext } from './types';

export const globalContext = createContext<GlobalContext>({});

export const GlobalContextProvider = globalContext.Provider;
